import React, { useCallback, useState } from "react";
import RequestAllObjectsArchiveForm from "./RequestAllObjectsArchiveForm";

type Props = {
  code: string;
};

export default function AllObjectsArchiveDownload({ code }: Props) {
  const [hasArchiveBeenRequested, setArchiveBeenRequested] = useState(false);

  const afterArchiveRequested = useCallback(() => {
    setArchiveBeenRequested(true);
  }, [setArchiveBeenRequested]);

  if (hasArchiveBeenRequested) {
    return (
      <p>
        Ihre ZIP-Archive werden aktuell erstellt. Die Download-Links senden wir
        Ihnen innerhalb der nächsten Stunde per E-Mail zu.
      </p>
    );
  }

  return (
    <RequestAllObjectsArchiveForm
      code={code}
      afterArchiveRequested={afterArchiveRequested}
    />
  );
}
